// extracted by mini-css-extract-plugin
export default {"education_expertise":"ResumeDetails_education_expertise__gKUo7","box":"ResumeDetails_box__Xibll","content":"ResumeDetails_content__MsmlK"};